import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { AddProductMenuController } from '../controller/AddProductMenuController';
import { AddProductViewData } from '../types/types';

export class AddProductMenuWebComponent extends BaseWebComponentElement {
  public controller: AddProductMenuController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AddProductMenuController,
    });
  }

  public setViewData(viewData: AddProductViewData) {
    this.controller?.view.setViewData(viewData);
  }

  public async reloadMenu() {
    await this.controller?.reloadMenu();
  }

  public getViewData(): AddProductViewData | boolean {
    if (this.controller) {
      return this.controller.view.getViewData();
    }
    return false;
  }
}
